"use client"

import LocalizedClientLink from "@/modules/common/components/localized-client-link"

/**
 * Short warm brand sentence for homepage — keeps visitors in buying mode.
 * Full timeline lives on the About Us (O nas) page.
 */
const OurStory = () => (
  <section className="bg-cream py-10 sm:py-12 text-center">
    <div className="container mx-auto px-4 sm:px-6">
      <p className="text-neutral-600 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
        Že tri desetletja smo vaš partner v kuhinji — družinsko podjetje, ki raste z vami.
        <LocalizedClientLink href="/about-us" className="text-navy font-medium hover:text-gold ml-1 transition-colors">
          Naša zgodba →
        </LocalizedClientLink>
      </p>
    </div>
  </section>
)

export default OurStory
